import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c4753e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center justify-content-between gap-3 p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none",
    href: "#",
    "data-bs-toggle": "modal",
    "data-bs-target": "#CreateServiceModal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline me-2" }, "Criar novo serviço"),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative fs-12" })
  ])
], -1))
const _hoisted_4 = { class: "service-list-filters d-flex flex-column flex-sm-row align-items-sm-center gap-3 ms-lg-auto" }
const _hoisted_5 = { class: "service-category-filter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "service_category_filter",
  class: "visually-hidden"
}, "Filtrar serviços por categoria", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todas as categorias", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "service-search-filter d-flex align-items-center",
  style: {"position":"relative","z-index":"99"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Comece a digitar para buscar serviços.", -1))
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Serviço "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Categoria "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Subcategoria "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Valor "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Tempo de execução "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Editar "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Deletar ")
  ])
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "7",
  class: "text-center text-muted py-4",
  role: "status"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_33 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_34 = { "aria-label": "Paginação de serviços" }
const _hoisted_35 = { class: "pagination mb-0" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteServiceModal = _resolveComponent("DeleteServiceModal")!
  const _component_CreateServiceModal = _resolveComponent("CreateServiceModal")!
  const _component_UpdateServiceModal = _resolveComponent("UpdateServiceModal")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteServiceModal),
    _createVNode(_component_CreateServiceModal),
    _createVNode(_component_UpdateServiceModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              id: "service_category_filter",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategoryId) = $event)),
              class: "form-select",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadPage(1)))
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategories, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: category.id,
                  value: category.id
                }, _toDisplayString(category.name), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedCategoryId]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_multiselect, {
              ref: "serviceSelect",
              modelValue: _ctx.selectedSearchService,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSearchService) = $event)),
              options: _ctx.filteredSearchServices,
              searchable: true,
              loading: _ctx.isLoadingServices,
              "internal-search": false,
              "custom-label": _ctx.formatServiceOption,
              taggable: false,
              label: "name",
              "track-by": "id",
              "no-options-text": "Nenhum serviço encontrado.",
              "no-result-text": "Nenhum resultado para sua busca.",
              placeholder: "Buscar serviço...",
              onSearchChange: _ctx.debouncedFetchServices,
              onSelect: _ctx.onServiceSelect,
              "close-on-select": true,
              id: "service_search",
              class: "w-100"
            }, {
              noOptions: _withCtx(() => [
                _hoisted_10
              ]),
              noResult: _withCtx(() => [
                _createTextVNode(" Nenhum serviço encontrado ")
              ]),
              _: 1
            }, 8, ["modelValue", "options", "loading", "custom-label", "onSearchChange", "onSelect"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("tbody", null, [
              (_ctx.isLoadingServiceList || _ctx.serviceListError || !_ctx.getServiceList.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.isLoadingServiceList ? 'Carregando serviços...' : (_ctx.serviceListError || 'Nenhum serviço encontrado para esta categoria.')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getServiceList, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("th", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(value.name), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(value.category.name), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(value.subcategory?.name || '-'), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(value.price_type === 'STARTING_AT' ? 'A partir de ' : '') + "R$ " + _toDisplayString(value.price_formatted), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatTime(value.time)), 1),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.setCurrentUpdateService(value)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#UpdateServiceModal",
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button"
                        }, _hoisted_27, 8, _hoisted_25)
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.setCurrentDeleteService(value)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#DeleteServiceModal",
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button"
                        }, _hoisted_31, 8, _hoisted_29)
                      ])
                    ]))
                  }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getServicesPagination.last_page ? _ctx.getServicesPagination.last_page : 1) + " — Total de " + _toDisplayString(_ctx.getServicesPagination.total ? _ctx.getServicesPagination.total : (_ctx.getServiceList ?
            _ctx.getServiceList.length : 0)) + " serviços ", 1),
          _createElementVNode("nav", _hoisted_34, [
            _createElementVNode("ul", _hoisted_35, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                  disabled: _ctx.isLoadingServiceList || !!_ctx.serviceListError || _ctx.currentPage <= 1
                }, " Anterior ", 8, _hoisted_36)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= (_ctx.getServicesPagination.last_page ? _ctx.getServicesPagination.last_page : 1) }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "page-link",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                  disabled: _ctx.isLoadingServiceList || !!_ctx.serviceListError || _ctx.currentPage >= (_ctx.getServicesPagination.last_page ? _ctx.getServicesPagination.last_page : 1)
                }, " Próxima ", 8, _hoisted_37)
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}